import { tv } from 'tailwind-variants';

export const menuStyles = tv({
  base: [
    'p-1.5 outline-0 min-w-48 max-h-[inherit] overflow-auto [clip-path:inset(0_0_0_0_round_.75rem)]',
  ],
});

export const menuItemStyles = tv({
  base: [
    'group',
    'flex items-center gap-2',
    'py-1.5 px-2.5 rounded-md text-sm',
    'cursor-default select-none outline-0 forced-color-adjust-none',
  ],
  variants: {
    isDisabled: {
      false: 'text-secondary-900',
      true: 'text-secondary-300 forced-colors:text-[GrayText]',
    },
    isFocused: {
      true: 'bg-primary text-primary-contrast forced-colors:bg-[Highlight] forced-colors:text-[HighlightText]',
      false: 'bg-0',
    },
  },
  compoundVariants: [
    {
      isFocused: false,
      isOpen: true,
      className: 'bg-secondary-100',
    },
  ],
});

export const menuSectionStyles = tv({
  base: [
    'first:-mt-2 mt-1',
    'after:content-[""] after:block after:h-1',
  ],
});

export const menuSectionHeaderStyles = tv({
  base: [
    '-mx-1.5 px-2.5 py-1 [&+*]:mt-1',
    'truncate font-medium text-xs text-secondary-600',
    'bg-secondary-100 border-y border-y-secondary-200',
  ],
});
